import React, {ReactNode} from 'react';
import cx from 'classnames';
import {isRTL} from '../../../../Localization';
import {createDataTestId} from '../../../../utils/dataTestId';
import styles from './style.module.scss';

type Props = {
    componentClasses?: string;
    text?: string;
    children?: ReactNode;
    onClick?: (event) => void;
    suffixElement?: ReactNode;
    disabled?: boolean;
    testId?: string;
};

export const ActionButton = ({
    componentClasses,
    text,
    children,
    onClick,
    disabled,
    testId,
    suffixElement = null
}: Props) => {
    return (
        <button
            className={cx(styles.wrapper, componentClasses, {
                [styles.disabled]: disabled
            })}
            onClick={!disabled ? onClick : undefined}
            disabled={disabled}
            dir={isRTL() ? 'rtl' : 'ltr'}
            {...createDataTestId(testId, false)}
        >
            {!!children ? <span className={'pui-action-btn-prefix'}>{children}</span> : null}
            <span className={cx(styles.text, 'action-btn__text')}>{text}</span>
            {!!suffixElement ? (
                <span className={'pui-action-btn-suffix'}>{suffixElement}</span>
            ) : null}
        </button>
    );
};
